import React from 'react';
import { Box, Grid, Card, CardContent, Typography, CardMedia } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

const FarmData = () => {
  // Dados de exemplo
  const farm = {
    name: 'Fazenda Aurora',
    location: 'Indaiatuba, SP, Brasil',
    technicalManager: 'João Silva',
    totalArea: '120 hectares',
    soilType: 'Argiloso',
    photoUrl: 'https://via.placeholder.com/500x300.png?text=Foto+da+Fazenda',
    mapCoordinates: [-23.346933, -47.887825], // Coordenadas de exemplo
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', padding: '20px', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        Dados da Fazenda
      </Typography>

      {/* Cards organizados em duas colunas */}
      <Grid container spacing={3}>
        {/* Coluna da esquerda */}
        <Grid item xs={12} sm={6}>
          {/* Card Nome e Localização */}
          <Card sx={{ padding: '16px', boxShadow: 2, marginBottom: '20px' }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Nome da Fazenda</Typography>
              <Typography variant="body1">{farm.name}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: '20px' }}>Localização</Typography>
              <Typography variant="body1">{farm.location}</Typography>
            </CardContent>
          </Card>

          {/* Card Área Total, Tipo de Solo e Responsável Técnico */}
          <Card sx={{ padding: '16px', boxShadow: 2, marginBottom: '20px' }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Área Total</Typography>
              <Typography variant="body1">{farm.totalArea}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: '20px' }}>Tipo de Solo</Typography>
              <Typography variant="body1">{farm.soilType}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: '20px' }}>Responsável Técnico</Typography>
              <Typography variant="body1">{farm.technicalManager}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Coluna da direita */}
        <Grid item xs={12} sm={6}>
          {/* Card Foto da Fazenda */}
          <Card sx={{ padding: '16px', boxShadow: 2, marginBottom: '20px' }}>
            <CardMedia
              component="img"
              alt="Foto da Fazenda"
              height="200"
              image={farm.photoUrl}
            />
          </Card>

          {/* Card Mapa da Fazenda */}
          <Card sx={{ padding: '16px', boxShadow: 2, marginBottom: '20px' }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Mapa da Fazenda</Typography>
              <MapContainer
                center={farm.mapCoordinates}
                zoom={13}
                style={{ width: '100%', height: '200px', marginTop: '20px' }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={farm.mapCoordinates}>
                  <Popup>{farm.name}</Popup>
                </Marker>
              </MapContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FarmData;
